import { NgIf } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DomSanitizer } from '@angular/platform-browser';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { TFMCartService } from 'app/mock-api/tfm-cart.service';
import { TFMService } from 'app/mock-api/tfm.service';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-add-service-item-dialog',
  standalone: true,
  imports: [FormsModule, NgIf, MatTooltipModule],
  templateUrl: './add-service-item-dialog.component.html',
  styleUrl: './add-service-item-dialog.component.scss'
})
export class AddServiceItemDialogComponent {

  public view: any = {
    // service: {
    //   supplier: '',
    //   service: '',
    //   cost: null,
    //   exchangeRateCurrent: null,
    //   price: null,
    //   start: null,
    //   end: null,
    //   adultCount: null,
    //   teenCount: null,
    //   childCount: null,
    //   infantCount: null,
    //   internalNote: '',
    //   chk1: false
    // }
  };

  trip: any = {};
  tripPointSelected: any;
  /** Basis dropdown: one of the preset options or 'Other' for custom. */
  basisChoice: string = '';
  readonly basisOptions = ['Per person', 'Per room', 'Total', 'Per night', 'Per vehicle'];
  public testMode = false;
  public searchTabId: number = 1;
  isEmailValid: boolean;
  urlViewItinerary: any;
  urlViewVoucher: any;
  urlViewInvoice: any;

  public calendar = {
    getToday: () => new Date(),
    getNext: (date: Date, unit: string, value: number) => {
      const result = new Date(date);
      switch (unit) {
        case 'd': // Days
          result.setDate(result.getDate() + value);
          break;
        case 'm': // Months
          result.setMonth(result.getMonth() + value);
          break;
        case 'y': // Years
          result.setFullYear(result.getFullYear() + value);
          break;
        default:
          break;
      }
      return result;
    }
  };

  public minDate: Date;
  public user: any = {};


  constructor(private _tfmService: TFMService, private _tfmCartService: TFMCartService, public sanitizer: DomSanitizer, public dialogRef: MatDialogRef<AddServiceItemDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private dialog: MatDialog) {
    console.log("Data - : ", data);
    this.view.service = this.data.service;
    this.view.guid = this.data.guid;
    this.view.focusMealAndRoomOnly = !!this.data.focusMealAndRoomOnly;
    this._syncBasisChoiceFromService();
  }

  private _syncBasisChoiceFromService(): void {
    const basis = (this.view.service?.basis || '').trim();
    if (basis && this.basisOptions.includes(basis)) {
      this.basisChoice = basis;
    } else if (basis) {
      this.basisChoice = 'Other';
    } else {
      this.basisChoice = '';
    }
  }

  onBasisChange(value: string): void {
    if (value && value !== 'Other') {
      this.view.service.basis = value;
    } else if (value !== 'Other') {
      this.view.service.basis = '';
    }
  }
  ngOnInit(): void {
    this._tfmService.getLoggedInUser().subscribe(res => {
      this.user = res;

      if (this.user.agentType == 'AGENT')
        this.minDate = this.calendar.getNext(this.calendar.getToday(), 'd', 5);
      else
        this.minDate = this.calendar.getToday();

      //this.toDate = calendar.getNext(calendar.getToday(), 'd', 10);
    });

  }
  openConfirmationModal(config?: { title?: string; message?: string; showClose?: boolean; showViewQuotes?: boolean; showNewQuote?: boolean; }) {
    return this.dialog.open(ConfirmationDialogComponent, {
      data: config
    });
  }
  closeModal(): void {
    this.dialogRef.close();
  }
  saveServiceItem() {
    if (this.view.service) {
      console.log("Save service item", this.view.service);

      if (this.view.service.id > 0) {
        this._tfmService.filterAndSend(this.view.service._links, "edit", this.view.service).subscribe(
          res => {
            console.log("Service updated");
            this.dialogRef.close();
            const dialogRef = this.openConfirmationModal({
              title: 'Service updated',
              message: 'The service has been updated successfully',
              showClose: true,
              showViewQuotes: false,
              showNewQuote: false
            });
            dialogRef.afterClosed().subscribe(() => {
              window.location.reload();  // Reload after modal is closed
            });
          },
          error => {
            console.error("Failed to update service", error);
            // Show error modal instead
            this.openConfirmationModal({
              title: 'Update failed',
              message: 'Failed to update the service. Please try again.',
              showClose: true,
              showViewQuotes: false,
              showNewQuote: false
            });
          }
        );
      }
      else {
        if (this.data.guid) {
          this.view.service.searchType = 1;
          this._tfmService.getItin(this.data.guid).subscribe((res) => {
            console.log('Response:', res);

            let link = this._tfmService.getLink(res.content.itinerary._links, "add-item-custom");
            console.log('link', link)

            if (link) {
              link.href = link.href.replace("{itineraryId}", res.id);

              this._tfmService.send(link, this.view.service).subscribe(
                (response) => {
                  console.log('Send Response:', response);
                  this.dialogRef.close();
                  const dialogRef = this.openConfirmationModal({
                    title: 'Service added',
                    message: 'The service has been added successfully',
                    showClose: true,
                    showViewQuotes: false,
                    showNewQuote: false
                  });
                  dialogRef.afterClosed().subscribe(() => {
                    window.location.reload();  // Reload after modal is closed
                  });
                },
                (error) => {
                  console.error('Send Error:', error);
                  this.openConfirmationModal({
                    title: 'Add failed',
                    message: 'Failed to add the service. Please try again.',
                    showClose: true,
                    showViewQuotes: false,
                    showNewQuote: false
                  });
                }
              );
            } else {
              console.error('Link not found: add-item-custom');
              this.openConfirmationModal({
                title: 'Error',
                message: 'System error: Unable to add service',
                showClose: true,
                showViewQuotes: false,
                showNewQuote: false
              });
            }
          },
            error => {
              console.error('Get Itin Error:', error);
              this.openConfirmationModal({
                title: 'Error',
                message: 'Failed to load itinerary data',
                showClose: true,
                showViewQuotes: false,
                showNewQuote: false
              });
            });
        }
      }
    }
  }

}
